import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { DateUtils } from 'ng-jhipster';

import { CardType } from './card-type.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class CardTypeService extends AbstractEntityService {

    protected resourceUrl = 'api/card-types';
    private resourceSearchUrl = 'api/_search/card-types';
    protected resourceCountUrl = 'api/_search/count/card-types';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(cardType: CardType): Observable<CardType> {
        let copy: CardType = Object.assign({}, cardType);
        copy.defaultEndDate = this.dateUtils
            .convertLocalDateToServer(copy.defaultEndDate);
        copy.defaultStartDate = this.dateUtils
            .convertLocalDateToServer(copy.defaultStartDate);
        return this.http.post<CardType>(this.resourceUrl, copy).map((res: CardType) => {
            return res;
        });
    }

    update(cardType: CardType): Observable<CardType> {
        let copy: CardType = Object.assign({}, cardType);
        copy.defaultEndDate = this.dateUtils
            .convertLocalDateToServer(copy.defaultEndDate);
        copy.defaultStartDate = this.dateUtils
            .convertLocalDateToServer(copy.defaultStartDate);
        return this.http.put<CardType>(this.resourceUrl, copy).map((res: CardType) => {
            return res;
        });
    }

    find(id: number): Observable<CardType> {
        return this.http.get<CardType>(`${this.resourceUrl}/${id}`).map((res: CardType) => {
            let jsonResponse = res;
            jsonResponse.defaultEndDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.defaultEndDate);
            jsonResponse.defaultStartDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.defaultStartDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceUrl, options)
        .map((res: HttpResponse<CardType[]>) => this.convertResponse(res))
                    ;
            ;
    }

    search(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceSearchUrl, options)
            ;
    }

    private convertResponse(res: HttpResponse<CardType[]>): any {
            let jsonResponse = res.body;
            for (let i = 0; i < jsonResponse.length; i++) {
                jsonResponse[i].defaultEndDate = this.dateUtils
                    .convertLocalDateFromServer(jsonResponse[i].defaultEndDate);
                jsonResponse[i].defaultStartDate = this.dateUtils
                    .convertLocalDateFromServer(jsonResponse[i].defaultStartDate);
            }
            return res.clone({body: jsonResponse});
        }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.service.ts